import { handleAnd, handleOr } from './handle-logical-operators';
import { handleFieldOperators } from './handle-field-operators';
import { createError } from './utils/create-error';
export function evaluateDocument(document, query, operators) {
    for (const [key, condition] of Object.entries(query)) {
        if (key.startsWith('$')) {
            switch (key) {
                case '$and': {
                    if (!handleAnd(document, condition, (d, q) => evaluateDocument(d, q, operators))) {
                        return false;
                    }
                    break;
                }
                case '$or': {
                    if (!handleOr(document, condition, (d, q) => evaluateDocument(d, q, operators))) {
                        return false;
                    }
                    break;
                }
                default: {
                    createError(`Unsupported root operator: ${key}`);
                }
            }
        }
        else {
            if (!handleFieldOperators(document, key, condition, operators)) {
                return false;
            }
        }
    }
    return true;
}
